import { updatePassword } from '@/js/api/account.ts';
import { clearField, FIELD_SELECTOR, showFieldError } from '@/js/fields.ts';
import { ERROR_REQUEST_TEXT, showErrorNotify, showSuccessNotify } from '@/js/notification.ts';

const SUCCESS_REQUEST_TEXT = 'Ваш пароль успешно изменен!';

function clearFormFields(form: HTMLFormElement) {
  const fields = form.querySelectorAll<HTMLElement>(FIELD_SELECTOR);
  for (const field of fields) {
    clearField(field);
  }
}
export function initUpdatePasswordForm() {
  const form = document.querySelector<HTMLFormElement>('.js-form-update-password');
  if (!form)
    return;

  form.addEventListener('submit', handleFormSubmit);

  function handleFormSubmit(event: Event): void {
    event.preventDefault();
    if (!form) {
      return;
    }
    clearFormFields(form);
    void formAsync(form);
  }

  async function formAsync(form: HTMLFormElement): Promise<void> {
    const formData = new FormData(form);
    const password = formData.get('password')?.toString() ?? '';
    const passwordConfirmation = formData.get('password_confirmation')?.toString() ?? '';

    if (password !== passwordConfirmation) {
      showFieldError(form.querySelector('[name="password"]'), 'Ошибка! Пароли не совпадают');
      return;
    }
    if (password.length < 8) {
      showFieldError(form.querySelector('[name="password"]'), 'Ошибка! Пароль меньше 8 символов');
      return;
    }

    try {
      const response = await updatePassword(formData);
      if (response.data?.success) {
        showSuccessNotify({ text: SUCCESS_REQUEST_TEXT });
      }
      else {
        showErrorNotify({ text: ERROR_REQUEST_TEXT });
      }
    }
    catch (error) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }
}
